import React, {useContext} from 'react'
import {BrowserRouter as Router, Redirect, Route, Switch,} from 'react-router-dom'

import {Toaster} from 'react-hot-toast'
import BackToTop from './Components/BackToTop'
import Header from './Components/Header'
import Toolbar from './Components/Header/Toolbar'
import Navigation from './Components/Navigation/Navigation'
import {DimensionsContext} from './utils/dimensions-context'
import classNames from 'classnames'
import styles from '../CSS/main.css'
import Comments from './routes/Comments/Comments'
import Users from './routes/Users/Users'
import Websites from './routes/Websites/Websites'
import URLs from './routes/URLs/URLs'
import CommentDetails from './routes/Comments/Details'
import {Routes} from './routing'
import EditWebsite from "./routes/EditWebsite";
import CommentHistory from './routes/CommentHistory'
import FilterWords from './routes/FilterWords'

export const AppRouter = (): JSX.Element => {
  const { minimized } = useContext(DimensionsContext).state

  const containerClass = classNames({
    [styles.Container]: true,
    [styles.MinimizedContainer]: minimized,
  })

  return (
    <Router>
      <div className={containerClass}>
        <Header />
        <Toolbar />
        <Switch>
          <Route path={Routes.Comments} exact component={Comments} />
          <Route
            path={Routes.CommentDetails}
            exact
            component={CommentDetails}
          />
          <Route path={Routes.CommentHistory} exact component={CommentHistory} />
          <Route path={Routes.Users} exact component={Users} />
          <Route path={Routes.Websites} exact component={Websites} />
          <Route path={Routes.EditWebsite} exact component={EditWebsite} />
          <Route path={Routes.URLs} exact component={URLs} />
          <Route path={Routes.FilterWords} component={FilterWords} />
          <Redirect to={Routes.Comments} />
        </Switch>
        <div>
          <Navigation />
        </div>
        <BackToTop />
        <Toaster />
      </div>
    </Router>
  )
}
